// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { ArrowLeftOutlined } from '@ant-design/icons';

// const ClubWeb = () => {
//   const [select, setSelect] = useState('Select Club');
//   const [isClicked, setIsClicked] = useState(false);
//   const [clubName, setClubName] = useState([]);
//   const [translatedData, setTranslatedData] = useState([]);
//   const [showMember, setShowMember] = useState(false);
//   const [ad, setAd] = useState([]);
//    const navigate = useNavigate();
//   const dist = sessionStorage.getItem("dist");

//   const clubNameShow = async () => {
//     try {
//       const res = await axios.get('https://lionsdirectoryapi.emedha.in/club/api/clubName/get', {
//         params: { dist }
//       });
//       setClubName(res.data);
//     } catch (err) {
//       console.error("Error fetching club names:", err);
//     }
//   };

//   const selectedClubMember = (search) => {
//     setSelect(search);
//     setIsClicked(false);
//     setShowMember(true);
//     axios.post('https://lionsdirectoryapi.emedha.in/club/api/search/club', { search, dist })
//       .then((resp) => setTranslatedData(resp.data))
//       .catch((error) => console.error("Error fetching club data:", error));
//   };

//   const search = (search) => {
//     axios.post('https://lionsdirectoryapi.emedha.in/club/api/search/club', { search, dist })
//       .then((resp) => setClubName(resp.data));
//   };

//   const show_advertisement = () => {
//     axios.post('https://lionsdirectoryapi.emedha.in/advertise/get', { ad_page: 'club', dist })
//       .then((res) => setAd(res.data));
//   };

//   useEffect(() => {
//     clubNameShow();
//     show_advertisement();
//   }, []);

//   return (
//     <div style={{
//       width: '365px', minHeight: '557px', maxHeight: '667px', margin: '10px auto',
//       border: '1px solid #ccc', borderRadius: '20px', overflow: 'hidden',
//       boxShadow: '0 0 10px rgba(0,0,0,0.2)', backgroundColor: '#f8f9fa', padding: '10px',
//       fontFamily: 'Arial, sans-serif'
//     }}>
//      <div style={{
//       backgroundColor: '#fff',
//       padding: '15px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'space-between',
//       marginBottom: 10
//     }}>
//       <div style={{ display: 'flex', alignItems: 'center' }}>
//         <ArrowLeftOutlined
//           style={{
//             fontSize: '18px',
//             color: '#0e3972',
//             cursor: 'pointer',
//             marginRight: '10px'
//           }}
//           onClick={() => navigate('/home')} // or the correct route for HomeScreen
//         />
//         <h6 style={{ color: '#0e3972', fontWeight: 'bold', margin: 0 }}>Club Info</h6>
//       </div>
//     </div>



//       {ad.map(data => (
//         <img key={data.id} src={data.image} alt="Ad" style={{ width: '340px', height: '250px', marginBottom: '10px' }} />
//       ))}

//       <div
//         onClick={() => { setIsClicked(!isClicked); setShowMember(false); clubNameShow(); }}
//         style={{
//           padding: '10px', backgroundColor: '#fff', borderRadius: '4px', marginBottom: '10px',
//           display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', color: 'rgb(14, 57, 114)', fontWeight: 'bold', fontSize: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
//         }}>
//         {select} <span>{isClicked ? '▲' : '▼'}</span>
//       </div>

//       {isClicked && (
//         <div style={{ backgroundColor: '#fff', borderRadius: '4px', padding: '10px', maxHeight: '300px', overflowY: 'auto' }}>
//           <input type="text" placeholder="Search Clubs" onChange={e => search(e.target.value)}
//             style={{ width: '100%', padding: '8px 30px', borderRadius: '4px', marginBottom: '10px' }} />
//           {clubName.map((club, index) => (
//             <div key={club.clubName} onClick={() => selectedClubMember(club.clubName)}
//               style={{ padding: '8px', borderBottom: '1px solid rgb(14, 57, 114)', cursor: 'pointer' }}>
//               {index + 1} {club.clubName}
//             </div>
//           ))}
//         </div>
//       )}

//       {showMember && (
//         <div style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '4px', marginTop: '10px', maxHeight: '250px', overflowY: 'auto' }}>
//           {translatedData.map(member => (
//             <div key={member.clubName} style={{ marginBottom: '15px', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
//               <div style={{ marginBottom: '5px', fontWeight: 'bold' }}>Member ID: {member.clubNumber}</div>
//               {[
//                 ['Club Name', member.clubName],
//                 ['President', member.president],
//                 ['Charter President', member.charterPresident],
//                 ['Secretary', member.secretory],
//                 ['Treasurer', member.treasurer],
//                 ['Charted on', member.chartedOn],
//                 ['Extn Chairperson', member.extnChairperson],
//                 ['Region Chairperson', member.regionChairperson],
//                 ['Zone Chairperson', member.zoneChairperson],
//                 ['Total Members', member.totalMembers],
//                 ['Sponsored By', member.clubSponsoredBy],
//               ].map(([label, value], idx) => (
//                 <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
//                   <span>{label}</span><span style={{ fontSize: label === 'Sponsored By' ? '12px' : '14px' }}>{value}</span>
//                 </div>
//               ))}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default ClubWeb;

import React, { useState, useEffect } from 'react';
import { ChevronLeft, Search, ChevronRight } from 'lucide-react';
import axios from 'axios';

const ClubsList = ({ onBack, onSelectClub, styles }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [clubs, setClubs] = useState([]);
  const [loading, setLoading] = useState(false);

  const dist = sessionStorage.getItem("dist");

  /* ---------------- FETCH ALL CLUBS ---------------- */
/* ---------------- FETCH ALL CLUBS ---------------- */
const fetchClubs = async () => {
  try {
    setLoading(true);
    const res = await axios.post(
      `https://lionsdirectoryapi.emedha.in/club/api/search/club`,
      {
        search: "", // empty = fetch all
        dist: dist
      }
    );
    setClubs(res.data);
  } catch (err) {
    console.error(err);
    alert("Error fetching clubs");
  } finally {
    setLoading(false);
  }
};

  /* ---------------- SEARCH CLUBS ---------------- */
  const searchClubs = async (value) => {
    try {
      setLoading(true);
      const res = await axios.post(
        `https://lionsdirectoryapi.emedha.in/club/api/search/club`,
        {
          search: value,
          dist: dist
        }
      );
      setClubs(res.data);
    } catch (err) {
      console.error(err);
      alert("Error searching clubs");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- LOAD ON MOUNT ---------------- */
  useEffect(() => {
    fetchClubs();
  }, []);

  /* ---------------- HANDLE SEARCH INPUT ---------------- */
  const handleSearch = (value) => {
    setSearchTerm(value);

    if (value.trim() === '') {
      fetchClubs();
    } else {
      searchClubs(value);
    }
  };

  return (
    <div style={styles.scrollArea}>
      {/* Header */}
      <div style={{ backgroundColor: '#0033A0', padding: '15px', display: 'flex', alignItems: 'center', gap: '15px', color: 'white' }}>
        <ChevronLeft onClick={onBack} style={{ cursor: 'pointer' }} />
        <h2 style={{ fontSize: '18px', margin: 0 }}>Search Clubs</h2>
      </div>

      {/* Search */}
      <div style={{ padding: '15px', borderBottom: '1px solid #eee' }}>
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
          <Search size={18} style={{ position: 'absolute', left: '12px', color: '#888' }} />
          <input 
            type="text" 
            placeholder="Search Clubs..." 
            value={searchTerm}
            onChange={(e) => handleSearch(e.target.value)}
            style={{ width: '100%', padding: '12px 12px 12px 40px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '14px' }}
          />
        </div>

        <p style={{ fontSize: '12px', color: '#666', marginTop: '10px' }}>
          {loading ? "Loading..." : `${clubs.length} clubs found`}
        </p>
      </div>

      {/* List */}
      <div style={{ padding: '10px 15px' }}>
        {clubs.map((club, index) => (
          <div 
            key={index}
            onClick={() => onSelectClub(club)}
            style={{ 
              display: 'flex',
              alignItems: 'center',
              padding: '15px',
              backgroundColor: 'white',
              borderRadius: '10px',
              marginBottom: '10px',
              border: '1px solid #eee',
              boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
              cursor: 'pointer'
            }}
          >
            <div style={{ 
              backgroundColor: '#E8EEFB',
              color: '#0033A0',
              width: '30px',
              height: '30px',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '12px',
              fontWeight: 'bold',
              marginRight: '15px'
            }}>
              {index + 1}
            </div>

            <span style={{ flex: 1, fontWeight: '500', color: '#333' }}>
              {club.clubName}
            </span>

            <ChevronRight size={18} color="#ccc" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClubsList;